import { FilterItem } from "../../../../../../../dashboard/reports/components/table/utils/styled";
import FormControl from "@mui/material/FormControl";
import { InputLabel, NativeSelect } from "../../../../../../../../common/styles/muiStyled";
import React from "react";
import { FilterProps } from "../../../../../../types";
import { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";

type Props = Omit<FilterProps, "config" | 'filterTableData'>;

export const StatusFilter = ({ filterSetters, filterGetters }: Props) => {
  const { t } = useTranslation('common');

  const onChange = (e: SelectChangeEvent) => {
    filterSetters.onBadgeStatusFilterChange(e.target.value);
  }

  return (
    <FilterItem>
      <FormControl fullWidth>
        <InputLabel>{t('companyPage.badgeStatus')}</InputLabel>
        <NativeSelect value={filterGetters.selectedBadgeStatus} onChange={onChange}>
          {filterGetters.statusOptions.map(row => <option value={row.status} key={row.status}>{row.label}</option>)}
        </NativeSelect>
      </FormControl>
    </FilterItem>
  );
};
